// Built from Mockup-v2/site.js for the Shopify theme. Edit the mockup, then rebuild.
var MJA = window.MJA || "";
(() => {
  // ---------- Icon sprite (one stroke family, 24px grid) ----------
  const icons = {
    'i-arrow': '<path d="M5 12h14M13 6l6 6-6 6"/>',
    'i-arrow-l': '<path d="M19 12H5M11 6l-6 6 6 6"/>',
    'i-arrow-ur': '<path d="M7 17 17 7M8 7h9v9"/>',
    'i-search': '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    'i-user': '<circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/>',
    'i-bag': '<path d="M5 8h14l-1.2 12.1a1 1 0 0 1-1 .9H7.2a1 1 0 0 1-1-.9L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>',
    'i-menu': '<path d="M4 8h16M4 16h16"/>',
    'i-close': '<path d="M6 6l12 12M18 6 6 18"/>',
    'i-truck': '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
    'i-clock': '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    'i-return': '<path d="M4 9h11a5 5 0 0 1 0 10H8"/><path d="m8 5-4 4 4 4"/>',
    'i-award': '<circle cx="12" cy="9" r="5.5"/><path d="m8.5 13.5-1.5 7 5-2.5 5 2.5-1.5-7"/>',
    'i-plug': '<path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0V8ZM12 17v4"/>',
    'i-hanger': '<path d="M12 7.5a2 2 0 1 1 2-2c0 1.2-2 1.6-2 3.2"/><path d="M12 8.7 3.6 15a1.2 1.2 0 0 0 .7 2.1h15.4a1.2 1.2 0 0 0 .7-2.1L12 8.7Z"/>',
    'i-sparkle': '<path d="M12 3.5 13.8 9l5.7 1.8-5.7 1.8L12 18.3l-1.8-5.7L4.5 10.8 10.2 9 12 3.5Z"/><path d="M19 17v4M17 19h4"/>',
    'i-check': '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    'i-x': '<path d="M7 7l10 10M17 7 7 17"/>',
    'i-plus': '<path d="M12 5v14M5 12h14"/>',
    'i-minus': '<path d="M5 12h14"/>',
    'i-star': '<path d="m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.8L12 3.5Z"/>',
    'i-fold': '<path d="M4 7h16v4H4zM6 11v6h12v-6"/><path d="M10 14h4"/>',
    'i-shield': '<path d="M12 3.5 19 6v5.5c0 4.3-3 7.7-7 9-4-1.3-7-4.7-7-9V6l7-2.5Z"/><path d="m9 12 2.2 2.2L15.5 10"/>',
    'i-box': '<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/>',
    'i-heart': '<path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10Z"/>',
    'i-mail': '<rect x="3.5" y="5.5" width="17" height="13" rx="2.5"/><path d="m4 7 8 6 8-6"/>',
    'i-question': '<circle cx="12" cy="12" r="8.5"/><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.1-2.4 3.7M12 17h.01"/>',
    'i-info': '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.5M12 7.8h.01"/>',
    'i-receipt': '<path d="M6 3.5h12v17l-3-2-3 2-3-2-3 2v-17Z"/><path d="M9 8h6M9 12h6"/>',
    'i-pin': '<path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.3"/>',
    'i-chat': '<path d="M5 5.5h14a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5H10l-4.5 3.5V17H5A1.5 1.5 0 0 1 3.5 15.5V7A1.5 1.5 0 0 1 5 5.5Z"/>',
    'i-edit': '<path d="M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17v3Z"/><path d="m14.5 7.5 3 3"/>',
    'i-pause': '<path d="M9 6v12M15 6v12"/>',
    'i-play': '<path d="M8 5.5v13l11-6.5-11-6.5Z"/>'
  };
  const ns = 'http://www.w3.org/2000/svg';
  const sprite = document.createElementNS(ns, 'svg');
  sprite.setAttribute('aria-hidden', 'true');
  sprite.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  sprite.innerHTML = Object.entries(icons).map(([id, d]) => `<symbol id="${id}" viewBox="0 0 24 24">${d}</symbol>`).join('');
  document.body.prepend(sprite);
  document.querySelectorAll('svg.ico').forEach(s => s.setAttribute('viewBox', '0 0 24 24'));
  document.querySelectorAll('.stars svg').forEach(s => s.setAttribute('viewBox', '0 0 24 24'));

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // ---------- Ratings (PLACEHOLDER numbers live in catalog.js) ----------
  if (window.MOJOCO) {
    const R = window.MOJOCO.rating;
    $$('[data-hero-rating]').forEach(el => (el.innerHTML = window.MOJOCO.ratingLink('dryer', 'rating-sm')));
    $$('[data-cmp-rating]').forEach(el => (el.innerHTML = window.MOJOCO.starsHTML(R, 'rating-sm')));
    const M = window.MOJOCO.products.dryer.mentions;
    $$('[data-mentions]').forEach(el => (el.innerHTML = `<div class="mn-group"><span class="mn-label">Used most for</span><ul>${M.uses.map(u => `<li>${u}</li>`).join('')}</ul></div><div class="mn-group"><span class="mn-label">Praised for</span><ul>${M.praise.map(u => `<li>${u}</li>`).join('')}</ul></div><p class="mn-src">Summarised from Amazon's review highlights for the Portable Dryer.</p>`));
    $$('[data-proof-score]').forEach(el => (el.innerHTML = `<b class="ps-num">${R.avg}</b><span class="ps-txt">${window.MOJOCO.starsHTML(R)}<span>From ${R.count.toLocaleString()} Amazon ratings of the Portable Dryer</span><a class="ps-amz" href="${window.MOJOCO.products.dryer.amazon}" target="_blank" rel="noopener">Read them on Amazon <svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><use href="#i-arrow-ur"/></svg></a></span>`));
    $$('.rating svg, .stars svg').forEach(s => s.setAttribute('viewBox', '0 0 24 24'));
  }

  // ---------- Every page opens at the top (or at its #anchor) ----------
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  // The page may be shown inside a viewer frame that scrolls on the outside,
  // so scrollIntoView (which also scrolls ancestor frames) is used, not just window.scrollTo.
  const landing = () => {
    const h = location.hash.slice(1);
    const t = h && (document.getElementById(h) || (['dryer', 'washer', 'travel', 'lint', 'shoe'].includes(h) && document.getElementById('shop')));
    const target = t || document.documentElement;
    window.scrollTo(0, 0);
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
  landing();
  window.addEventListener('load', landing, { once: true });
  window.addEventListener('pageshow', e => { if (e.persisted) landing(); });

  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Nav: glass at the top, rolls away on scroll down, unrolls on scroll up ----------
  const nav = $('.nav');
  let lastY = window.scrollY, ticking = false;
  const onScroll = () => {
    ticking = false;
    if (!nav) return;
    const y = window.scrollY, dy = y - lastY;
    nav.classList.toggle('is-stuck', y > 40 || nav.dataset.alwaysStuck === '1');
    const menuOpen = document.querySelector('[data-menu]')?.dataset.open === 'true';
    if (menuOpen || y < 120) nav.classList.remove('is-rolled');
    else if (dy > 6) nav.classList.add('is-rolled');
    else if (dy < -6) nav.classList.remove('is-rolled');
    if (Math.abs(dy) > 6) lastY = y;
  };
  if (nav && nav.classList.contains('is-stuck')) nav.dataset.alwaysStuck = '1';
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  nav && nav.addEventListener('focusin', () => nav.classList.remove('is-rolled'));
  onScroll();

  // ---------- Nav dropdowns: open on hover (with a short close delay) or click; Escape and outside click close ----------
  const dropBtns = $$('[data-drop-btn]');
  let dropTimer = null, openKey = null;
  const setDrop = key => {
    clearTimeout(dropTimer);
    document.documentElement.classList.toggle('drop-switch', !!(openKey && key && openKey !== key));
    openKey = key;
    document.documentElement.classList.toggle('drop-open', !!key);
    dropBtns.forEach(b => {
      const on = b.dataset.dropBtn === key, panel = $(`[data-drop="${b.dataset.dropBtn}"]`);
      b.setAttribute('aria-expanded', String(on));
      if (!panel) return;
      panel.dataset.open = String(on);
    });
  };
  const closeSoon = () => { clearTimeout(dropTimer); dropTimer = setTimeout(() => setDrop(null), 180); };
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  dropBtns.forEach(b => {
    const panel = $(`[data-drop="${b.dataset.dropBtn}"]`);
    b.addEventListener('click', () => setDrop(openKey === b.dataset.dropBtn ? null : b.dataset.dropBtn));
    if (hoverable) {
      b.addEventListener('mouseenter', () => setDrop(b.dataset.dropBtn));
      b.addEventListener('mouseleave', closeSoon);
      panel && panel.addEventListener('mouseenter', () => clearTimeout(dropTimer));
      panel && panel.addEventListener('mouseleave', closeSoon);
    }
    panel && panel.addEventListener('focusout', e => { if (!panel.contains(e.relatedTarget) && e.relatedTarget !== b) setDrop(null); });
  });
  document.addEventListener('click', e => { if (openKey && !e.target.closest('[data-drop], [data-drop-btn]')) setDrop(null); });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape' || !openKey) return;
    const btn = $(`[data-drop-btn="${openKey}"]`); setDrop(null); btn && btn.focus();
  });
  window.addEventListener('scroll', () => { if (openKey && nav && nav.classList.contains('is-rolled')) setDrop(null); }, { passive: true });

  // ---------- FAQ answers roll open and closed (all <details class="qa">, including ones rendered later) ----------
  document.addEventListener('click', e => {
    const sum = e.target.closest('details.qa > summary');
    if (!sum || calm) return;
    const d = sum.parentElement;
    let body = d.querySelector(':scope > .qa-body');
    if (!body) { body = document.createElement('div'); body.className = 'qa-body'; [...d.children].filter(c => c !== sum).forEach(c => body.append(c)); d.append(body); }
    e.preventDefault();
    if (body._anim) body._anim.cancel();
    const opening = !d.open || d.dataset.closing === '1';
    if (opening) {
      delete d.dataset.closing; d.open = true;
      const h = body.scrollHeight;
      body._anim = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.22, 1, .36, 1)' });
    } else {
      d.dataset.closing = '1';
      body._anim = body.animate([{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'cubic-bezier(.4, 0, 1, 1)' });
      const done = () => { if (d.dataset.closing === '1') { d.open = false; delete d.dataset.closing; } };
      body._anim.onfinish = done;
      setTimeout(done, 300);
    }
  });

  // ---------- Mobile menu ----------
  const menuBtn = $('[data-menu-btn]');
  const menu = $('[data-menu]');
  const setMenu = open => {
    if (!menu) return;
    menu.dataset.open = String(open);
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    $('use', menuBtn).setAttribute('href', open ? '#i-close' : '#i-menu');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) nav && nav.classList.remove('is-rolled');
  };
  menuBtn && menuBtn.addEventListener('click', () => setMenu(menu.dataset.open !== 'true'));
  menu && $$('a', menu).forEach(a => a.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && menu?.dataset.open === 'true') setMenu(false); });

  // ---------- Hero carousel: cross-fade every 5s (keeps going under the mouse), pauses on keyboard focus, off for reduced motion ----------
  const car = $('[data-carousel]');
  if (car) {
    const slides = $$('[data-slide]', car), dots = $$('[data-dot]', car), pauseBtn = $('[data-pause]', car);
    let idx = 0, timer = null, userPaused = calm, hovering = false;
    // Warm every slide's photo once the page has loaded, so no slide fades in before its image is ready
    const warm = () => slides.forEach(s => { const im = $('img', s); if (im) { im.loading = 'eager'; im.decode && im.decode().catch(() => {}); } });
    const idle = window.requestIdleCallback || (f => setTimeout(f, 300));
    document.readyState === 'complete' ? idle(warm) : window.addEventListener('load', () => idle(warm), { once: true });
    const show = i => {
      const next = slides[(i + slides.length) % slides.length], im = next && $('img', next);
      if (im && !im.complete) { im.loading = 'eager'; (im.decode ? im.decode() : Promise.resolve()).catch(() => {}).then(() => reveal(i)); return; }
      reveal(i);
    };
    const reveal = i => {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === idx;
        s.classList.toggle('is-on', on);
        on ? s.removeAttribute('aria-hidden') : s.setAttribute('aria-hidden', 'true');
        $$('a', s).forEach(a => on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'));
      });
      dots.forEach((d, k) => d.setAttribute('aria-current', String(k === idx)));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { stop(); if (!userPaused && !hovering) timer = setInterval(() => show(idx + 1), 5000); };
    const setPaused = p => {
      userPaused = p;
      pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
      $('use', pauseBtn).setAttribute('href', p ? '#i-play' : '#i-pause');
      p ? stop() : start();
    };
    dots.forEach(d => d.addEventListener('click', () => { show(+d.dataset.dot); start(); }));
    pauseBtn.addEventListener('click', () => setPaused(!userPaused));
    car.addEventListener('focusin', () => { hovering = true; stop(); });
    car.addEventListener('focusout', () => { hovering = false; start(); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    setPaused(userPaused);
    // Swipe left/right between slides on touch screens
    let sx = 0, sy = 0;
    car.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    car.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { show(idx + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });
  }

  // ---------- Trust strip: one message at a time on phones ----------
  const trust = $('[data-trust]');
  if (trust) {
    const items = $$('li', trust);
    let ti = 0, tt = null;
    const phone = window.matchMedia('(max-width: 640px)');
    const paint = () => items.forEach((li, k) => li.classList.toggle('is-on', k === ti));
    const run = () => {
      clearInterval(tt); tt = null;
      if (phone.matches && !calm) { paint(); tt = setInterval(() => { ti = (ti + 1) % items.length; paint(); }, 3200); }
      else { items.forEach(li => li.classList.add('is-on')); }
    };
    phone.addEventListener ? phone.addEventListener('change', run) : phone.addListener(run);
    run();
  }

  // ---------- Toast + cart drawer ----------
  const ico = n => `<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><use href="#${n}"/></svg>`;
  const toast = $('[data-toast]');
  let toastTimer;
  const showToast = msg => {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = msg;
    toast.dataset.show = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (toast.dataset.show = 'false'), 3200);
  };
  const CC = window.MOJOCO;
  // Cart backend. Everything between the markers returns the same "view":
  // { lines: [{ key, id, name, variant, qty, unit, total, img, url, addon }], count, subtotal, savings }.
  // The mockup keeps the cart in this browser; the theme build swaps this block for Shopify's cart API.
  // >>> cart backend (Shopify)
  const keyFor = h => CC.order.find(k => CC.url(k) === '/products/' + h);
  const viewOf = c => {
    const lines = c.items.map(it => {
      const k = keyFor(it.handle), addon = it.handle === 'mojoco-dryer-rod-clamp';
      return { key: it.key, id: k || it.handle, name: k ? CC.products[k].name.replace(' 4L', '') : addon ? CC.products.dryer.addon.name : it.product_title, variant: it.product_has_only_default_variant ? '' : it.variant_title, qty: it.quantity, unit: it.final_price / 100, total: it.final_line_price / 100, img: k ? CC.products[k].cut : addon ? null : it.image, url: it.url, addon };
    });
    lines.sort((x, y) => x.addon - y.addon); // the add-on sits under the product it goes with
    return { lines, count: c.item_count, subtotal: c.total_price / 100, savings: c.total_discount / 100 };
  };
  const call = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(r => { if (!r.ok) throw new Error(url); return r.json(); });
  const cartGet = () => call('/cart.js').then(viewOf);
  const cartAdd = items => call('/cart/add.js', { items: items.filter(i => i.vid).map(i => ({ id: i.vid, quantity: i.qty })) }).then(cartGet);
  const cartChange = (key, qty) => call('/cart/change.js', { id: key, quantity: qty }).then(viewOf);
  // <<< cart backend

  let view = { lines: [], count: 0, subtotal: 0, savings: 0 };
  const rodArt = '<svg class="cd-rod" viewBox="0 0 48 48" aria-hidden="true"><path d="M6 16h36"/><path d="M14 16v7h6v-7M14 23v12h6V23"/><circle cx="42" cy="16" r="2"/></svg>';
  const cd = $('[data-cd]');
  const paintCount = bump => {
    const n = view.count;
    $$('[data-cart-count]').forEach(c => {
      c.textContent = n;
      if (bump) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 400); }
    });
    $$('[data-cart]').forEach(b => b.setAttribute('aria-label', `Cart, ${n} item${n === 1 ? '' : 's'}`));
  };
  const render = () => {
    if (!cd) return;
    const n = view.count;
    $('[data-cd-count]', cd).textContent = n ? `(${n})` : '';
    $('[data-cd-foot]', cd).hidden = !n;
    $$('[data-cd-sub]', cd).forEach(el => (el.textContent = CC.fmt(view.subtotal)));
    const save = $('[data-cd-save]', cd);
    if (save) { save.hidden = !view.savings; $('b', save).textContent = '−' + CC.fmt(view.savings); }
    if (!n) {
      $('[data-cd-body]', cd).innerHTML = `<div class="cd-empty">${ico('i-bag')}<p>Your cart is empty.</p><a class="btn btn-primary" href="/#range">Shop the range</a></div>`;
      return;
    }
    // One quiet suggestion: what the current page pairs with, or the lint remover
    const here = CC.current && CC.current.pairs ? CC.current.pairs : ['lint', 'dryer', 'shoe'];
    const sug = here.find(k => CC.products[k] && CC.products[k].price != null && !view.lines.some(l => l.id === k));
    $('[data-cd-body]', cd).innerHTML = `<ul class="cd-lines">${view.lines.map(l => `<li class="cd-line">
        <a class="cd-img" href="${l.url}" tabindex="-1" aria-hidden="true">${l.img ? `<img src="${l.img}" alt="">` : rodArt}</a>
        <div class="cd-info">
          <a class="cd-name" href="${l.url}">${l.name}</a>
          ${l.variant ? `<span class="cd-var">${l.variant}</span>` : ''}
          <div class="cd-qty" role="group" aria-label="Quantity, ${l.name}"><button type="button" data-key="${l.key}" data-set="${l.qty - 1}" aria-label="One less"${l.qty < 2 ? ' disabled' : ''}>−</button><output>${l.qty}</output><button type="button" data-key="${l.key}" data-set="${l.qty + 1}" aria-label="One more"${l.qty > 8 ? ' disabled' : ''}>+</button></div>
        </div>
        <div class="cd-end"><b>${CC.fmt(l.total)}</b><button type="button" class="cd-rm" data-key="${l.key}" data-set="0" aria-label="Remove ${l.name}">Remove</button></div>
      </li>`).join('')}</ul>${sug ? `<div class="cd-up"><span class="caps">Pairs well with</span>
      <div class="cd-up-row"><span class="cd-img"><img src="${CC.products[sug].cut}" alt=""></span><span class="cd-up-txt"><b>${CC.products[sug].name.replace(' 4L', '')}</b><span>${CC.fmt(CC.products[sug].price)}</span></span><button type="button" class="cd-up-add" data-up="${sug}">Add</button></div></div>` : ''}`;
  };
  const refresh = (v, bump) => { view = v; paintCount(bump); render(); return v; };
  const openCart = note => {
    if (!cd) return;
    const added = $('[data-cd-added]', cd);
    added.innerHTML = note ? `${ico('i-check')}<span>${note}</span>` : '';
    added.hidden = !note;
    render();
    if (!cd.open) { cd.showModal(); requestAnimationFrame(() => cd.classList.add('is-in')); }
  };
  const closeCart = () => { if (!cd || !cd.open) return; cd.classList.remove('is-in'); setTimeout(() => cd.close(), 280); };
  // Every change waits for the cart to answer; the drawer dims while it does
  const act = p => {
    cd && cd.classList.add('is-busy');
    return p.then(v => refresh(v, false))
      .catch(() => showToast('Could not update the cart. Please try again.'))
      .finally(() => cd && cd.classList.remove('is-busy'));
  };
  const addToCart = (items, note) => cartAdd(items).then(v => { refresh(v, true); openCart(note); return v; });
  if (cd) {
    cd.addEventListener('click', e => {
      const t = e.target;
      if (t === cd || t.closest('[data-cd-close]')) return closeCart();
      if (cd.classList.contains('is-busy')) return;
      const set = t.closest('[data-set]'), up = t.closest('[data-up]');
      if (set) act(cartChange(set.dataset.key, +set.dataset.set));
      else if (up) {
        const k = up.dataset.up;
        $('[data-cd-added]', cd).hidden = true;
        act(cartAdd([{ id: k, variant: k === 'washer' ? '4L' : '', qty: 1, vid: CC.products[k].variantId }]));
      }
    });
    cd.addEventListener('cancel', e => { e.preventDefault(); closeCart(); });
  }
  $$('[data-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  cartGet().then(v => refresh(v, false)).catch(() => {});
  window.__mojoco = { addToCart, openCart, showToast };

  // ---------- Product explorer (one room, five products) ----------
  // In the Shopify theme each entry becomes a block on the section: product picker, scene image, hotspots.
  const CAT = window.MOJOCO;
  const PRODUCTS = [
    { id: 'dryer', tag: 'Best seller', name: 'Portable Clothes Dryer', price: CAT.priceText(CAT.products.dryer), note: 'Free shipping', href: CAT.url('dryer'), cta: 'Shop the dryer',
      img: MJA + 'scene-dryer.webp?v=b7a2e423', thumb: MJA + 'dryer.webp?v=07343dd4', alt: 'MOJOCO Portable Clothes Dryer hanging from an oak rod in a powder-blue living room',
      line: 'Dries light laundry anywhere there is an outlet. Hangs from a rod, folds flat to store.',
      spots: [
        { x: 49, y: 17, ico: 'i-plug', t: 'Plugs into any standard outlet', d: 'No dryer hookup, no vent hose, nothing drilled into the wall.' },
        { x: 50, y: 46, ico: 'i-hanger', t: 'Holds up to 9 light items', d: 'Tees, underwear, socks, baby clothes and delicates on hangers.' },
        { x: 57, y: 28, ico: 'i-sparkle', t: 'UV LED sanitize mode', d: 'Runs while it dries. Good for baby clothes and delicates.' },
        { x: 46, y: 68, ico: 'i-clock', t: '20–50 minutes for light items', d: 'Set the timer and walk away. Thicker fabrics take longer.' } ] },
    { id: 'washer', tag: 'Washer', name: 'Portable Washer 4L', price: CAT.priceText(CAT.products.washer), note: 'Also in 6L', href: CAT.url('washer'), cta: 'Shop the washer',
      img: MJA + 'scene-washer.webp?v=2331664f', thumb: MJA + 'washer.webp?v=641e995d', alt: 'MOJOCO 4L portable washer washing socks and a baby onesie on a marble bathroom counter',
      line: 'Small loads, washed anywhere. Fill it, press start, no hose or hookup.',
      spots: [
        { x: 47, y: 38, ico: 'i-hanger', t: '4L tank for small loads', d: 'Socks, underwear, baby clothes and delicates.' },
        { x: 48, y: 71, ico: 'i-clock', t: '6, 12 or 20 minute cycles', d: 'One-button control on the front display.' },
        { x: 59, y: 66, ico: 'i-plug', t: 'Rechargeable, cordless washing', d: 'Charges by USB-C, then runs on battery.' } ] },
    { id: 'travel', tag: 'Travel', name: 'Travel Clothes Dryer', price: CAT.priceText(CAT.products.travel), note: 'Free shipping', href: CAT.url('travel'), cta: 'Shop the travel dryer',
      img: MJA + 'scene-travel.webp?v=d0706c66', thumb: MJA + 'travel.webp?v=8328c942', alt: 'MOJOCO Travel Clothes Dryer hanging from a closet rod in a hotel room, drying a shirt in its garment cover',
      line: 'The dryer that packs. Cover, cord and hangers all store inside the unit.',
      spots: [
        { x: 55, y: 60, ico: 'i-box', t: '1.98 lbs, everything stores inside', d: 'Cover, cord and hangers fold into the body.' },
        { x: 56, y: 9, ico: 'i-plug', t: 'Works on 100–240V', d: 'Global voltage. Bring a plug adapter.' },
        { x: 49, y: 12, ico: 'i-sparkle', t: 'Two heat settings', d: 'Low for delicates, high for everyday drying.' },
        { x: 52, y: 38, ico: 'i-hanger', t: 'Up to 5 light garments', d: 'Built-in hanger hooks inside the cover.' } ] },
    { id: 'lint', tag: 'New', name: 'Lint Remover', price: CAT.priceText(CAT.products.lint), note: '', href: CAT.url('lint'), cta: 'Shop the lint remover',
      img: MJA + 'scene-lint.webp?v=e51e40bf', thumb: MJA + 'lint.webp?v=e784a23f', alt: 'MOJOCO Lint Remover standing on a folded knit sweater on an oak side table',
      line: 'Lifts pills and fuzz off sweaters, coats and throws so they look new again.',
      spots: [
        { x: 46, y: 35, ico: 'i-sparkle', t: '3 speed levels', d: 'Gentle on fine knits, faster on heavy fabrics.' },
        { x: 49, y: 46, ico: 'i-plug', t: 'USB-C rechargeable', d: 'The digital display shows battery level.' },
        { x: 48, y: 59, ico: 'i-box', t: 'Push-to-empty container', d: 'Slide, push, done. No brush needed.' } ] },
    { id: 'shoe', tag: 'New', name: 'Shoe Dryer', price: CAT.priceText(CAT.products.shoe), note: '', href: CAT.url('shoe'), cta: 'Shop the shoe dryer',
      img: MJA + 'scene-shoe.webp?v=05266c3e', thumb: MJA + 'shoe.webp?v=e6fe3fb1', alt: 'MOJOCO Shoe Dryer drying white sneakers on an oak floor',
      line: 'Dries sneakers, boots and gloves overnight, right by the door.',
      spots: [
        { x: 34, y: 46, ico: 'i-hanger', t: 'Four adjustable tubes', d: 'Extend for tall boots, lower for sneakers.' },
        { x: 46, y: 54, ico: 'i-clock', t: 'Shoe, boot and night modes', d: 'Plus a built-in timer.' },
        { x: 57, y: 49, ico: 'i-sparkle', t: 'Deodorize mode', d: 'Freshens shoes and gear while they dry.' } ] }
  ];

  // ---------- House explorer: one apartment, spotlight per product ----------
  // Zones are in % of the panorama. In the Shopify theme each zone is a block on the section.
  const ZONES = {
    shoe:   { room: 'Entryway',    cx: 10.5, cy: 74, rx: 10, ry: 26, mx: 10.5, my: 57 },
    lint:   { room: 'Living room', cx: 31,   cy: 57, rx: 8,  ry: 16, mx: 31,   my: 47 },
    dryer:  { room: 'Hallway',     cx: 51,   cy: 39, rx: 8,  ry: 46, mx: 51,   my: 75 },
    washer: { room: 'Bathroom',    cx: 64,   cy: 46, rx: 6.5,ry: 19, mx: 64,   my: 31 },
    travel: { room: 'Bedroom',     cx: 82,   cy: 42, rx: 9,  ry: 46, mx: 82,   my: 76 }
  };
  const ORDER = ['shoe', 'lint', 'dryer', 'washer', 'travel'];
  const house = $('[data-house]');
  let exSelect = null;
  if (house) {
    const canvas = $('[data-house-canvas]', house);
    const pan = $('[data-house-pan]', house);
    const markers = $('[data-house-markers]', house);
    const card = $('[data-house-card]', house);
    const names = $('[data-house-names]');
    const byId = id => PRODUCTS.find(p => p.id === id);
    const short = n => n.replace('Portable Washer', 'Washer').replace(' 4L', '').replace('Portable Clothes ', '').replace('Travel Clothes ', 'Travel ');

    markers.innerHTML = ORDER.map(id => { const z = ZONES[id], p = byId(id);
      return `<button class="house-marker" type="button" style="left:${z.mx}%;top:${z.my}%" aria-pressed="false" data-zone="${id}"><span class="dot" aria-hidden="true"></span>${short(p.name)}</button>`; }).join('');
    names.innerHTML = ORDER.map(id => `<button type="button" role="tab" aria-selected="false" data-zone="${id}">${short(byId(id).name)}</button>`).join('');
    const mks = $$('.house-marker', markers), tabs = $$('button', names);
    let active = null;

    const placeCard = z => {
      if (window.matchMedia('(max-width: 760px)').matches) { card.style.left = card.style.top = ''; return; }
      const W = canvas.clientWidth, H = canvas.clientHeight, cw = card.offsetWidth, ch = card.offsetHeight, pad = 16;
      const zx = z.cx / 100 * W, zr = z.rx / 100 * W * .7;
      let x = z.cx < 55 ? zx + zr + 20 : zx - zr - 20 - cw;
      let y = z.cy / 100 * H - ch / 2;
      x = Math.max(pad, Math.min(x, W - cw - pad));
      y = Math.max(pad, Math.min(y, H - ch - pad));
      card.style.left = x + 'px'; card.style.top = y + 'px';
    };
    const open = id => {
      const z = ZONES[id], p = byId(id);
      active = id;
      house.dataset.active = id;
      canvas.style.setProperty('--cx', z.cx + '%'); canvas.style.setProperty('--cy', z.cy + '%');
      canvas.style.setProperty('--rx', z.rx + '%'); canvas.style.setProperty('--ry', z.ry + '%');
      mks.forEach(m => m.setAttribute('aria-pressed', String(m.dataset.zone === id)));
      tabs.forEach(t => t.setAttribute('aria-selected', String(t.dataset.zone === id)));
      $('[data-hc-room]', card).textContent = z.room;
      $('[data-hc-name]', card).textContent = p.name;
      const cp = CAT.products[id];
      $('[data-hc-price]', card).innerHTML = CAT.priceText(cp) + (cp.rating ? ' ' + CAT.starsHTML(cp.rating, 'rating-sm') : (cp.isNew ? ' <span class="new-pill">New</span>' : ''));
      $('[data-hc-facts]', card).innerHTML = p.spots.slice(0, 2).map(f => `<li><svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><use href="#i-check"/></svg>${f.t}</li>`).join('');
      $('[data-hc-link]', card).href = p.href;
      card.hidden = false;
      card.style.animation = 'none'; void card.offsetWidth; card.style.animation = '';
      if (phoneMQ.matches) framePhone(z); else placeCard(z);
    };
    // Phones: frame the chosen product on one side, card floats over the other side
    const phoneMQ = window.matchMedia('(max-width: 760px)');
    const framePhone = z => {
      const cw = canvas.clientWidth, vw = pan.clientWidth;
      const px = z.cx / 100 * cw;
      const max = Math.max(0, cw - vw);
      let left = Math.min(max, Math.max(0, px - vw * 0.26));
      const onScreen = px - left;
      house.dataset.cardSide = onScreen > vw * 0.5 ? 'left' : 'right';
      if (onScreen > vw * 0.5) left = Math.min(max, Math.max(0, px - vw * 0.74));
      pan.scrollTo({ left, behavior: calm ? 'auto' : 'smooth' });
    };
    const close = () => {
      if (phoneMQ.matches) return;
      active = null;
      delete house.dataset.active;
      card.hidden = true;
      mks.forEach(m => m.setAttribute('aria-pressed', 'false'));
      tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
    };
    exSelect = i => open(PRODUCTS[i].id);
    [...mks, ...tabs].forEach(b => b.addEventListener('click', e => { e.stopPropagation(); active === b.dataset.zone && !phoneMQ.matches ? close() : open(b.dataset.zone); }));
    $('[data-house-close]', card).addEventListener('click', close);
    canvas.addEventListener('click', e => { if (e.target === canvas || e.target.tagName === 'IMG') close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && active) close(); });
    window.addEventListener('resize', () => active && placeCard(ZONES[active]));

    // Hide the 'swipe to explore' hint once the visitor pans or picks a product
    const panned = () => house.setAttribute('data-panned', '');
    pan.addEventListener('scroll', () => { if (pan.scrollLeft > 24) panned(); }, { passive: true });
    [...mks, ...tabs].forEach(b => b.addEventListener('click', panned));

    // Phones: swipe the photo to move between products; always show one product
    let hx = 0, hy = 0;
    pan.addEventListener('touchstart', e => { hx = e.touches[0].clientX; hy = e.touches[0].clientY; }, { passive: true });
    pan.addEventListener('touchend', e => {
      if (!phoneMQ.matches) return;
      const dx = e.changedTouches[0].clientX - hx, dy = e.changedTouches[0].clientY - hy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        const k = ORDER.indexOf(active || ORDER[0]);
        open(ORDER[(k + (dx < 0 ? 1 : -1) + ORDER.length) % ORDER.length]);
      }
    }, { passive: true });
    window.addEventListener('resize', () => { if (phoneMQ.matches) { open(active || ORDER[0]); } });

    const start = location.hash.slice(1);
    if (ZONES[start]) requestAnimationFrame(() => open(start));
    else if (phoneMQ.matches) requestAnimationFrame(() => open(ORDER[0]));

    // Phones: a swipeable row of room cards, each cropped from the same house picture
    const roomRow = document.createElement('div');
    roomRow.className = 'house-m';
    roomRow.setAttribute('aria-label', 'Products by room');
    roomRow.innerHTML = ORDER.map(id => { const z = ZONES[id], p = byId(id), q = CAT.products[id];
      return `<a class="hm-card" href="${p.href}">
        <span class="hm-room"><img src="${MJA}house.webp?v=72775209" alt="" loading="lazy" style="transform:translate(-${Math.min(85, Math.max(16, z.cx))}%, -${Math.min(62, Math.max(38, z.cy))}%)"><span class="hm-tag">${z.room}</span></span>
        <span class="hm-info"><span><b>${short(p.name)}</b><span>${(id === 'washer' ? 'From ' : '') + p.price}${p.tag === 'New' ? ' · New' : ''}</span></span><span class="hm-go"><svg class="ico" aria-hidden="true"><use href="#i-arrow"/></svg></span></span>
      </a>`; }).join('');
    const roomDots = document.createElement('div');
    roomDots.className = 'house-m-dots'; roomDots.setAttribute('aria-hidden', 'true');
    roomDots.innerHTML = ORDER.map((id, i) => `<span${i ? '' : ' class="on"'}></span>`).join('');
    names.after(roomRow, roomDots);
    roomRow.addEventListener('scroll', () => {
      const i = Math.round(roomRow.scrollLeft / (roomRow.firstElementChild.offsetWidth + 12));
      $$('span', roomDots).forEach((d, k) => d.classList.toggle('on', k === i));
    }, { passive: true });
  }

  // Menu links that point at a product category open it in the explorer
  $$('[data-filter-link]').forEach(a => a.addEventListener('click', e => {
    const map = { wash: 'washer', care: 'lint' };
    const idx = PRODUCTS.findIndex(p => p.id === map[a.dataset.filterLink]);
    if (exSelect && idx >= 0) { e.preventDefault(); exSelect(idx); $('#shop').scrollIntoView({ behavior: calm ? 'auto' : 'smooth' }); setMenu(false); }
  }));

  // ---------- Rail ----------
  const rail = $('[data-rail]');
  if (rail) {
    const items = [...rail.children];
    const count = $('[data-rail-count]');
    const prev = $('[data-rail-prev]'), next = $('[data-rail-next]');
    const step = () => items[0].getBoundingClientRect().width + 16;
    const update = () => {
      const i = Math.min(items.length - 1, Math.round(rail.scrollLeft / step()));
      count.textContent = `${i + 1}/${items.length}`;
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
    });
    update();
  }

  // ---------- Signup ----------
  const form = $('[data-signup]');
  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = $('input', form);
      const msg = $('[data-signup-msg]', form);
      if (!input.checkValidity() || !input.value) {
        msg.textContent = 'Enter an email address like name@example.com.';
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      const body = new URLSearchParams({ form_type: 'customer', utf8: '\u2713', 'contact[email]': input.value, 'contact[tags]': 'newsletter' });
      fetch('/contact#contact_form', { method: 'POST', body })
        .then(() => { msg.textContent = "You're on the list. Watch your inbox for the next launch."; input.value = ''; })
        .catch(() => { msg.textContent = 'Something went wrong. Please try again.'; });
    });
  }

  // ---------- Form validation helper ----------
  const validate = form => {
    let first = null;
    $$('[required]', form).forEach(el => {
      const err = el.closest('.field')?.querySelector('.err');
      const ok = el.value.trim() !== '' && el.checkValidity();
      el.setAttribute('aria-invalid', String(!ok));
      if (err) err.textContent = ok ? '' : (el.dataset.err || 'Fill in this field.');
      if (!ok && !first) first = el;
    });
    if (first) first.focus();
    return !first;
  };

  // Generic help forms (contact, returns, warranty registration)
  $$('[data-form]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const msg = $('.form-msg', form);
      if (!validate(form)) { msg.textContent = ''; return; }
      const btn = $('button[type="submit"]', form);
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Sending…';
      setTimeout(() => {
        btn.disabled = false; btn.textContent = label;
        msg.textContent = form.dataset.success;
        form.reset();
      }, 700);
    });
  });

  // ---------- Order tracking (sample result) ----------
  const track = $('[data-track]');
  if (track) {
    const out = $('[data-track-result]');
    track.addEventListener('submit', e => {
      e.preventDefault();
      if (!validate(track)) { out.hidden = true; return; }
      const num = $('#track-order', track).value.trim().replace(/^#?/, '#');
      $('[data-track-num]', out).textContent = `Order ${num}`;
      const btn = $('button[type="submit"]', track);
      btn.disabled = true; btn.textContent = 'Looking up…';
      setTimeout(() => {
        btn.disabled = false; btn.textContent = 'Track order';
        out.hidden = false;
        out.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'nearest' });
      }, 600);
    });
  }

  // ---------- FAQ search ----------
  const faqSearch = $('[data-faq-search]');
  if (faqSearch) {
    const groups = $$('[data-faq-group]');
    const empty = $('[data-faq-empty]');
    faqSearch.addEventListener('input', () => {
      const q = faqSearch.value.trim().toLowerCase();
      let shown = 0;
      groups.forEach(g => {
        let n = 0;
        $$('.qa', g).forEach(qa => {
          const hit = !q || qa.textContent.toLowerCase().includes(q);
          qa.hidden = !hit;
          if (hit) { n++; if (q) qa.open = true; }
        });
        g.hidden = n === 0;
        shown += n;
      });
      empty.hidden = shown !== 0;
    });
  }

  // ---------- Copy email ----------
  $$('[data-copy]').forEach(b => b.addEventListener('click', async () => {
    const text = b.dataset.copy;
    try { await navigator.clipboard.writeText(text); showToast('Email address copied'); }
    catch {
      const t = $(b.dataset.copyTarget);
      if (t) { const r = document.createRange(); r.selectNodeContents(t); const s = getSelection(); s.removeAllRanges(); s.addRange(r); }
      showToast('Press Cmd+C to copy the selected address');
    }
  }));

  // ---------- Review filters ----------
  const rFilters = $$('[data-rfilter]');
  if (rFilters.length) {
    rFilters.forEach(b => b.addEventListener('click', () => {
      const f = b.dataset.rfilter;
      rFilters.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      $$('[data-rcat]').forEach(r => (r.hidden = !(f === 'all' || r.dataset.rcat === f)));
    }));
  }

  // ---------- Product page ----------
  const pdp = $('[data-pdp]');
  if (pdp) {
    // Gallery (thumbnails on desktop; swipe + dots on phones)
    const main = $('[data-gallery-main]');
    const thumbs = $$('[data-thumb]');
    const gm = main && main.closest('.g-main');
    if (gm) {
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'g-dots';
    dotsWrap.setAttribute('role', 'group');
    dotsWrap.setAttribute('aria-label', 'Product images');
    dotsWrap.innerHTML = thumbs.map((t, i) => `<button type="button" aria-label="Image ${i + 1} of ${thumbs.length}" aria-current="${i === 0}"></button>`).join('');
    gm.after(dotsWrap);
    const gDots = $$('button', dotsWrap);
    const current = () => Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-current') === 'true'));
    gDots.forEach((d, i) => d.addEventListener('click', () => thumbs[i].click()));
    let gx = 0, gy = 0;
    gm.addEventListener('touchstart', e => { gx = e.touches[0].clientX; gy = e.touches[0].clientY; }, { passive: true });
    gm.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - gx, dy = e.changedTouches[0].clientY - gy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        const n = (current() + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
        thumbs[n].click();
      }
    }, { passive: true });
    $$('[data-thumb]').forEach(t => t.addEventListener('click', () => {
      $$('[data-thumb]').forEach(x => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
      $$('.g-dots button').forEach((d, i) => d.setAttribute('aria-current', String(i === $$('[data-thumb]').indexOf(t))));
      main.style.opacity = '0';
      setTimeout(() => {
        main.src = t.dataset.src;
        main.alt = t.dataset.alt;
        main.onload = () => (main.style.opacity = '1');
      }, 160);
    }));
    }

    // Bundle + price (prices come from the catalog; Shopify variant data in the theme)
    const cur = window.MOJOCO.current;
    const C = window.MOJOCO;
    const bundle = $('[data-bundle]');
    const qtyOut = $('[data-qty-val]');
    const qty = () => (qtyOut ? +qtyOut.textContent : 1);
    const total = () => (cur.price + (bundle && bundle.checked ? cur.addon.price : 0)) * qty();
    const sync = () => { if (cur.price != null) $$('[data-total]').forEach(el => (el.textContent = C.fmt(total()))); };
    C.syncTotal = sync;
    bundle && bundle.addEventListener('change', sync);
    $$('[data-qty-step]').forEach(b => b.addEventListener('click', () => {
      const v = Math.min(9, Math.max(1, qty() + +b.dataset.qtyStep));
      $$('[data-qty-val]').forEach(o => (o.textContent = v));
      $$('[data-qty-step]').forEach(x => (x.disabled = (x.dataset.qtyStep === '-1' && qty() === 1) || (x.dataset.qtyStep === '1' && qty() === 9)));
      sync();
    }));
    $$('[data-qty-step="-1"]').forEach(x => (x.disabled = true));
    sync();

    $$('[data-add]').forEach(b => b.addEventListener('click', () => {
      if (b.dataset.busy) return;
      b.dataset.busy = '1';
      b.setAttribute('aria-busy', 'true');
      const label = $('[data-add-label]', b);
      const prevLabel = label.textContent;
      label.textContent = 'Adding…';
      const withAddon = bundle && bundle.checked, n = qty();
      const size = $('.pills [aria-pressed="true"]');
      const items = [{ id: cur.id, variant: cur.id === 'washer' && size ? size.textContent : '', qty: n, vid: cur.variantId }];
      if (withAddon) items.push({ id: 'addon', variant: '', qty: n, vid: cur.addon.variantId });
      const reset = () => { label.textContent = prevLabel; b.classList.remove('is-added'); delete b.dataset.busy; b.removeAttribute('aria-busy'); };
      addToCart(items, `${n > 1 ? n + ' × ' : ''}${cur.short}${withAddon ? ' + ' + cur.addon.name : ''} added`)
        .then(() => { label.innerHTML = `${ico('i-check')}Added`; b.classList.add('is-added'); setTimeout(reset, 1600); })
        .catch(() => { showToast('Could not add to cart. Please try again.'); reset(); });
    }));

    // Sticky mobile buy bar: only after the main buy button has scrolled up out of view
    const buyBar = $('[data-buybar]');
    const primary = $('[data-primary-buy]');
    // Phones and tablets: the bar is the buy button, so it shows from the start
    const barAlways = window.matchMedia('(max-width: 960px)');
    if (buyBar && primary && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        buyBar.dataset.show = String(barAlways.matches || (!e.isIntersecting && e.boundingClientRect.top < 0));
      }).observe(primary);
    }
    if (buyBar && barAlways.matches) buyBar.dataset.show = 'true';
  }
})();
